<template>
  <BasicLayout>
    <template #wrapper>
      <el-card>
        <clear-cache-apply />
        <sync-data />
      </el-card>

      <basic />
      <card />
      <spin />
      <recommend />
      <join />
      <emot />
    </template>
  </BasicLayout>
</template>

<script>

import basic from '@/views/config/club/components/basic.vue'
import card from '@/views/config/club/components/card.vue'
import spin from '@/views/config/club/components/spin.vue'
import recommend from '@/views/config/club/components/recommend.vue'
import join from '@/views/config/club/components/join.vue'
import emot from '@/views/config/club/components/emot.vue'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'
export default {
  name: 'MaxLevelRecord',
  components: {
    SyncData,
    ClearCacheApply,
    basic,
    card,
    spin,
    recommend,
    join,
    emot
  },
  data() {
    return {

    }
  }
}
</script>

<style scoped>
</style>
